import { render, staticRenderFns } from "./PostMenu.vue?vue&type=template&id=367c339c&"
import script from "./PostMenu.vue?vue&type=script&lang=js&"
export * from "./PostMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports